import alfredPricingQueries from "$/lib/queries/alfred-pricing-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/alfred-pricing")({
  loader: async ({ context: { queryClient } }) => {
    queryClient.prefetchQuery(alfredPricingQueries.catalog())
    return { crumb: "Alfred-priser" }
  },
})
